<div id="onboarding-payment-page">

  <div class="container-state-img">
    <img ngSrc="assets/images/payment-error.svg" alt="Icon payment error" height="80" width="80">
  </div>

  <app-onboarding-header
    title="Paiement refusé"
    content="Mince 😔, une erreur s'est produite lors du paiement. Veuillez réessayer.">
    [isStepperTitle]="true">
  </app-onboarding-header>

  <div class="container-actions">
    <button mat-stroked-button (click)="leave()"
            class="full-width size-xl base"
            type="button">
      Quitter
    </button>
    <button mat-flat-button
            class="full-width size-xl"
            color="accent"
            type="button" (click)="retry()">
      <div class="icon">
        <img ngSrc="assets/images/icons/white/retry.svg" alt="Icon retry" width="24" height="24"> Réssayer
      </div>
    </button>
  </div>
</div>
